export default "__VITE_ASSET__Bi907mNJ__"